
import { Enums } from '@bode-canada/core';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import Carousel from '@/ui-kit/components/carousel';
import CarouselItem from '@/ui-kit/components/carousel-item';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import { ViewListingAction } from '@/components/listing-card/helpers/actions';
import ListingCard from '@/components/listing-card';
import { CAROUSEL_BREAKPOINTS } from './constants';
import PaginationNavigator from '@/ui-kit/components/pagination-navigator/PaginationNavigator';
import { CarouselPropsEventType, CarouselSlotName } from '@/ui-kit/components/carousel/enums';
import { CarouselPagination } from '@/components/shared/listing-carousel/entites/CarouselPagination';

const CAROUSEL_REF_NAME = 'listing-carousel';

export default {
  name: 'ListingCarousel',
  components: {
    Carousel,
    CarouselItem,
    ListingCard,
    PaginationNavigator,
  },
  props: {
    listings: {
      type: Array,
      required: true,
    },
    isPaginationDisplayed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      StyleColorSchemeType,
      CarouselPropsEventType,
      CarouselSlotName,
      CAROUSEL_BREAKPOINTS,
      CAROUSEL_REF_NAME,
      pagination: null,
    };
  },
  created() {
    this.initPagination();
  },
  methods: {
    getViewListingAction({ origin }) {
      const analyticEvent = origin === Enums.ListingOriginEnum.BODE
        ? ListingPageEvent.BodeComparable
        : ListingPageEvent.MLSComparable;

      return new ViewListingAction({ analyticEvent });
    },
    initPagination() {
      this.pagination = new CarouselPagination({
        pageSize: 1,
        totalItems: this.listings.length,
        firstIndexOnPage: 1,
      });
    },
    handlePaginationChange(options) {
      this.pagination.setOptions({ ...options });
      this.$refs[CAROUSEL_REF_NAME].slideTo(this.pagination.firstIndexOnPage - 1);
    },
    handleActiveIndexChange(index) {
      this.pagination.setFirstIndexOnPage(index + 1);
    },
    handleBreakpointChange(breakpoint) {
      this.pagination.setPageSize(breakpoint.slidesPerView);
    },
  },
};
